import React from 'react';
import { BloqueioResponse } from 'common/genericTypes';
import { Typography } from '@material-ui/core';
import { bloqueioTipoDescriptions, constricaoTipoDescriptions } from 'common/genericDescriptions';
import { Section } from 'm2m.components';
import { addCpfCnpjMask } from 'utils/mask';
import { formatNumber } from 'utils/number';

interface Props {
  bloqueio: BloqueioResponse;
}

const DetalhesOperacaoBloqueio: React.FC<Props> = (props) => {
  const { bloqueio } = props;

  return (
    <Section title={'Detalhes do Bloqueio'} defaultGrid>
      <div>
        <Typography variant="body2">{'Tipo de Bloqueio:'}</Typography>
        <Typography variant="body1">{bloqueioTipoDescriptions[bloqueio.tipo]}</Typography>
      </div>
      <div>
        <Typography variant="body2">{'CPF/CNPJ do Investidor Garantidor:'}</Typography>
        <Typography variant="body1">{addCpfCnpjMask(bloqueio.investidorGarantidor.cpfCnpj)}</Typography>
      </div>
      <div>
        <Typography variant="body2">{'Custodiante do Garantidor:'}</Typography>
        <Typography variant="body1">{bloqueio.investidorGarantidor.razaoSocial}</Typography>
      </div>
      <div>
        <Typography variant="body2">{'Conta Depósito do Garantidor:'}</Typography>
        <Typography variant="body1">{bloqueio.investidorGarantidor.contaDeposito}</Typography>
      </div>
      <div>
        <Typography variant="body2">{'Código do Ativo:'}</Typography>
        <Typography variant="body1">{bloqueio.instrumentoFinanceiro.codigo}</Typography>
      </div>
      <div>
        <Typography variant="body2">{'Quantidade:'}</Typography>
        <Typography variant="body1">{formatNumber(bloqueio.quantidade, { minimumFractionDigits: 0, maximumFractionDigits: 8 })}</Typography>
      </div>
      {!!bloqueio.investidorGarantido && (
        <div>
          <Typography variant="body2">{'CPF/CNPJ do Investidor Garantido:'}</Typography>
          <Typography variant="body1">{addCpfCnpjMask(bloqueio.investidorGarantido.cpfCnpj)}</Typography>
        </div>
      )}
      {!!bloqueio.investidorGarantido && (
        <div>
          <Typography variant="body2">{'Custodiante do Garantido:'}</Typography>
          <Typography variant="body1">{bloqueio.investidorGarantido.razaoSocial}</Typography>
        </div>
      )}
      {!!bloqueio.investidorGarantido && (
        <div>
          <Typography variant="body2">{'Conta Depósito do Garantido:'}</Typography>
          <Typography variant="body1">{bloqueio.investidorGarantido.contaDeposito}</Typography>
        </div>
      )}
      {!!bloqueio.constricaoTipo && (
        <div>
          <Typography variant="body2">{'Tipo de Constrição:'}</Typography>
          <Typography variant="body1">{constricaoTipoDescriptions[bloqueio.constricaoTipo]}</Typography>
        </div>
      )}
    </Section>
  );
};

export default DetalhesOperacaoBloqueio;
